import { apiClient, API_PRX } from '@indipia/shared';

const BASE = API_PRX.MEMBER;

// ── 타입 ──────────────────────────────────────────────────────────────────────

export interface NotiSettings {
  inAppYn: 'Y' | 'N';
  pushYn: 'Y' | 'N';
  smsYn: 'Y' | 'N';
  kakaoYn: 'Y' | 'N';
  emailYn: 'Y' | 'N';
}

export type NotiSettingsPatch = Partial<Pick<NotiSettings, 'smsYn' | 'kakaoYn' | 'emailYn' | 'pushYn'>>;

// ── 알림 설정 조회 ────────────────────────────────────────────────────────────

export async function fetchNotiSettings(): Promise<NotiSettings> {
  const res = await apiClient.get(`${BASE}/users/noti-settings`);
  return res.data.data as NotiSettings;
}

// ── 알림 설정 수정 ────────────────────────────────────────────────────────────

export async function updateNotiSettings(patch: NotiSettingsPatch): Promise<void> {
  await apiClient.patch(`${BASE}/users/noti-settings`, patch);
}
